var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre-datetimepicker',_vm._g(_vm._b({attrs:{"input-class-name":_vm.className,"locale":_vm.$i18n.locale,"twelve-hour-time":_vm.twelveHourTime}},'pre-datetimepicker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }